<template>
  <div class="activity-feed" ref="activityTask">
    <ul class="list-unstyled">
      <li v-if="activityLog.length === 0" class="text-muted">
        Chưa có hoạt động nào.
      </li>

      <li
        v-for="item in activityLog"
        :key="item.id"
        class="mb-3 pb-3 border-bottom"
      >
        <div class="d-flex align-items-start">
          <a href="#" class="avatar"
            ><img alt="" :src="item.nguoiThucHien.avatarUrl"
          /></a>

          <div class="activity-content">
            <p class="mb-0">
              <strong class="mr-1">{{ item.nguoiThucHien.hoTen }}</strong>
              {{ item.moTa }}
            </p>
            <small class="text-muted">{{
              formatTimestamp(item.ngayTao)
            }}</small>
          </div>
        </div>
      </li>
    </ul>
    <div
      v-if="totalPages > 1"
      class="d-flex justify-content-center align-items-center"
    >
      <nav>
        <ul class="pagination mb-0">
          <li class="page-item" :class="{ disabled: currentPage === 0 }">
            <a
              class="page-link"
              href="#"
              @click.prevent="goToPage(currentPage - 1)"
              >Trước</a
            >
          </li>
          <li
            class="page-item"
            v-for="page in visiblePages"
            :key="page"
            :class="{ active: currentPage === page - 1 }"
          >
            <a
              v-if="page !== '...'"
              class="page-link"
              href="#"
              @click.prevent="goToPage(page - 1)"
              >{{ page }}</a
            >
            <span v-else class="page-link">...</span>
          </li>
          <li
            class="page-item"
            :class="{ disabled: currentPage === totalPages - 1 }"
          >
            <a
              class="page-link"
              href="#"
              @click.prevent="goToPage(currentPage + 1)"
              >Sau</a
            >
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script setup>
import nhatKyHoatDongService from "@/services/nhatKyHoatDongService";
import { computed, nextTick, onMounted, ref } from "vue";
import { useToast } from "vue-toastification";

const toast = useToast();
const props = defineProps({
  taskId: [Number],
});

const activityLog = ref([]);
const taskId = ref(props.taskId);

const currentPage = ref(0);
const pageSize = ref(12);
const totalElements = ref(0);
const totalPages = ref(0);
const activityTask = ref(null);

const fetchActivityTask = async () => {
  try {
    const params = {
      page: currentPage.value,
      size: pageSize.value,
    };
    const res = await nhatKyHoatDongService.getActivity(taskId.value, params);
    activityLog.value = res.data.content;
    totalElements.value = res.data.totalElements;
    totalPages.value = res.data.totalPages;
  } catch {
    toast.error("Không thể tải danh sách nhật ký");
  }
};

const formatTimestamp = (isoString) => {
  if (!isoString) return "";
  const date = new Date(isoString);
  return date.toLocaleString("vi-VN", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

// Logic hiển thị số trang cho pagination
const visiblePages = computed(() => {
  const pages = [];
  const maxVisible = 5;
  if (totalPages.value <= maxVisible + 2) {
    for (let i = 1; i <= totalPages.value; i++) pages.push(i);
  } else {
    pages.push(1);
    const current = currentPage.value + 1;
    let start = Math.max(2, current - Math.floor((maxVisible - 2) / 2));
    let end = Math.min(totalPages.value - 1, start + maxVisible - 3);
    start = Math.max(2, end - maxVisible + 3);

    if (start > 2) pages.push("...");
    for (let i = start; i <= end; i++) pages.push(i);
    if (end < totalPages.value - 1) pages.push("...");
    pages.push(totalPages.value);
  }
  return pages;
});

// HÀM ĐỂ CHUYỂN TRANG
const goToPage = (pageNumber) => {
  if (pageNumber >= 0 && pageNumber < totalPages.value) {
    currentPage.value = pageNumber;
    fetchActivityTask();
    nextTick(() => {
      // Kiểm tra nếu ref đã được gắn vào element
      if (activityTask.value) {
        activityTask.value.scrollTop = 0; // Cuộn lên đầu
      }
    });
  }
};

onMounted(() => {
  fetchActivityTask();
});
</script>

<style scoped>
/* * Chúng ta cần một chút CSS tùy chỉnh cho phần Avatar 
 * vì Bootstrap 4 không có component Avatar tròn chuẩn.
 */
.avatar > img {
  height: 100%;
  width: 38px;
  height: 38px;
}
.activity-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 0.9rem;
  /* flex-shrink: 0 để đảm bảo avatar không bị co lại khi nội dung quá dài */
  flex-shrink: 0;
}

.activity-content p {
  /* Đảm bảo text ngắt dòng nếu quá dài */
  word-break: break-word;
  line-height: 1.4;
  font-size: 0.95rem; /* Kích thước font dễ đọc hơn một chút */
}

/* Thêm đường viền mờ bên dưới mỗi mục, ngoại trừ mục cuối cùng */
.list-unstyled li:last-child {
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
  border-bottom: none !important;
}
</style>
